// UQ-fr-CA
module.exports = {
  "forTest": "test for UQ-fr-CA",
  "text_styling_book_header_title": "CARNET DE MODE",
  "text_styling_book_official_styling": "Style officiel",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Trier par",
  "text_filter": "Filtre",
  "text_styling_book_search_results_number": "Résultats {total}",
  "text_active_filters": "Filtres actifs",
  "text_styling_book_clear_all_filters": "Tout effacer",
  "text_styling_book_search_by_feature": "Rechercher par collection",
  "text_styling_book_search_by_category": "Rechercher par catégorie",
  "text_styling_book_staff_customer_filter_all": "Tout",
  "text_styling_book_search_by_coordinate": "Rechercher par mot-clé",
  "text_styling_book_staff_customer_filter_title": "Publié par",
  "text_styling_book_search_by_height": "Rechercher par taille",
  "text_styling_book_search_by_hashtag": "Rechercher par mot-clic",
  "text_styling_book_staff_customer_filter_customer_styling": "Clients",
  "text_styling_book_staff_customer_filter_staff_styling": "Employés UNIQLO",
  "text_apply_search_filter": "Appliquer",
  "text_styling_book_no_results": "Aucun résultat",
  "text_error_title": "Service temporairement non disponible",
  "text_503_error_description-1": "Toutes nos excuses. Une erreur s’est produite.",
  "text_503_error_description-2": "Veuillez accéder à ce site plus tard ou retourner à la page précédente à l’aide du bouton Précédent du navigateur.",
  "text_503_error_instruction": "Pour toute question, veuillez vous rendre à notre rubrique AIDE/CONTACTEZ-NOUS.",
  "text_styling_book_go_to_top": "Page d'accueil UNIQLO",
  "text_contactus": "Contactez-nous",
  "text_wishlist": "Liste de souhaits",
  "text_membership_info": "Mon compte",
  "text_wearing_items": "Les articles de la tenue",
  "text_color": "Couleur",
  "text_size": "Taille",
  "text_stylehint_non_listed_items_message_01": "*Les produits qui ne sont pas affichés sont indisponibles.",
  "text_styling_book_related_styling_title": "Vous aimerez aussi",
  "text_style_styling_date_update": "Mettre à jour",
  "text_styling_book_hashtag_title": "Mot-clic",
  "currency_format": "{price} $ CA",
  "text_404": "Page non trouvée",
  "text_official_styling_top_page_link": "Page d'accueil Style Officiel",
  "text_stylehint_top_page_link": "Page d'accueil StyleHint",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "Fermer",
  "text_log_in": "Ouverture de session",
  "text_app_update_dialog_cancel": "Annuler",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Tous droits réservés.",
  "text_stylehintapp": "Application StyleHint",
  "text_styling_book_official_styling_page_title": "Style Officiel",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Nouveautés",
  "text_styling_book_sort_popular": "Plus populaire(s)",
  "text_styling_book_search_by_color": "Rechercher par couleur",
  "text_filter_clear_all_category": "Effacer toutes les catégories",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Afficher tout",
  "text_error_description": "Une erreur de système s’est produite. Veuillez réessayer de nouveau ou plus tard.",
  "text_system_error": "Erreur de système",
  "text_ok": "OK",
  "text_login_required": "Ouverture de session requise",
  "text_login_request": "Veuillez aller à la page d'ouverture de session.",
  "text_error_failed_sort_product": "Les produits n’ont pas pu être triés sur la base des critères que vous avez sélectionnés. Relancez la fonction de tri.",
  "text_error_failed_update_filter_criteria": "Le critère de filtrage n’a pas pu être mis à jour. Veuillez réessayer.",
  "text_meta_title_postfix": "| UNIQLO CA",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Femme",
  "text_styling_book_meta_men": "Homme",
  "text_styling_book_meta_kids": "Enfant",
  "text_styling_book_meta_baby": "Bébé",
  "text_styling_book_official_gender_meta_description": "Parcourez notre Carnet de mode et trouvez la tenue idéale pour {gender} de la saison! Magasinez toutes les tenues ou ajoutez vos produits préférés à votre panier et faites vos achats plus tard.",
  "text_styling_book_official_gender_meta_title": "Découvrez les styles de la saison | {gender} | Style Officiel {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender} 「{filterOptions}」idées de style {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Découvrez nos tenues {gender}「{filterOptions}」avec les articles tendance de {brand}. Trouvez l'inspiration.",
  "text_styling_book_official_detail_meta_title": "Magasinez les tenues「 {officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Découvrez les nouveaux styles de saison de「{officialProducts} 」et faites vos achats sur {brand}.com dès maintenant!",
  "text_styling_book_stylehint_gender_meta_title": "Découvrez les nouvelles idées de style | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Laissez-vous inspirer par les tenues pour {gender} de nos clients et de {brand} que nos employés ont publiés sur l'appli StyleHint.",
  "text_styling_book_stylehint_filter_meta_title": "Idées de tenues pour「{filterOptions} {gender} {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Idées de tenues de {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Idées de tenues de {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Idées de tenues de {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Découvrez les idées de tenues pour 「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Renseignez-vous sur les idées de tenues {brand}({storeName}) de {staffName}({height}). Découvrez comment les employés créent leur style avec des produits tendance.",
  "text_styling_book_stylehint_ins_user_meta_description": "Découvrez les idées mode de l'utilisateur Instagram {userName} portant des articles de {brand} pour créer sa tenue. Trouvez l'inspiration avec encore plus d'utilisateurs.",
  "text_styling_book_stylehint_customer_user_meta_description": "Découvrez les idées de tenues de {userName} ({height}) portant les produits {brand} pour rester à la mode. Inspirez-vous des vêtements portés par nos mannequins sur notre boutique en ligne.",
  "text_styling_book_stylehint_detail_meta_description": "Familiarisez-vous avec les nouveaux styles {stylehintProducts} de nos clients et de nos employés {brand}. Faites vos achats sur {brand}.com dès maintenant!",
  "text_styling_book_stylehint_filter_meta_description": "Découvrez「{searchCount}」des idées de tenues「{filterOptions}」avec des articles de mode {brand}. Retrouvez les nouveautés et articles tendance sur la boutique en ligne.",
  "text_styling_book_stylehint_styling_id_alt_tag": "Idées du CARNET DE MODE {brand}: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "Idées du CARNET DE MODE {brand}: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Renseignez-vous sur les idées de tenues de「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Renseignez-vous sur les idées de tenues de「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Idées de tenues pour {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Idées de style pour {gender}「{feature}」",
  "text_style_model_height": "",
  "text_503_error_description": "Toutes nos excuses. Une erreur s'est produite. Veuillez accéder au site plus tard ou retourner à la page précédente à l'aide du bouton précédent.",
  "text_styling_book_meta_official_styling": "Idées de styles",
  "text_styling_book_meta_stylehint": "Idées de tenues",
  "text_limited_offer_until_date": "Offre à durée limitée valable jusqu’au {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Offre exclusive du magasin en ligne valable jusqu’au {date}",
  "text_app_membership_exclusive_limited_offer_until": "{flagName} jusqu'au {date}",
  "text_csoon_early": "Disponible début {month}",
  "text_csoon_mid": "Disponible mi-{month}",
  "text_csoon_late": "Disponible fin {month}",
  "text_men": "Homme",
  "text_women": "Femme",
  "text_kids": "Enfant",
  "text_baby": "Bébé",
  "text_unisex": "Non genré",
  "text_app_membership_exclusive_limited_offer": "Offres exclusives réservées aux membres de l'appli",
  "text_styling_book_gender_menu_kids_and_baby": "Enfant / Bébé",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Ajouter à la liste de souhaits",
  "text_close": "Fermer",
  "text_error_wishlist_max": "Cet article ne peut pas être ajouté. Vous avez dépassé le nombre maximum d'articles sur votre liste de souhaits.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Aucune image",
  "text_wearing_size_code01": "Taille du vêtement: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "Français",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "Ce produit n’est plus en vente.",
  "text_product_display_markdown": "",
  "text_color_white": "Blanc",
  "text_color_gray": "Gris",
  "text_color_black": "Noir",
  "text_color_pink": "Rose",
  "text_color_red": "Rouge",
  "text_color_orange": "Orange",
  "text_color_beige": "Beige",
  "text_color_brown": "Brun",
  "text_color_yellow": "Jaune",
  "text_color_green": "Vert",
  "text_color_blue": "Bleu",
  "text_color_purple": "Violet",
  "text_promotion": "Promotion",
  "text_styling_promotion_hashtag": "Promotion",
  "text_coming_soon": "Bientôt disponible",
  "text_markdown": "Soldes",
  "text_multibuy_markdown": "Achats multiples, soldes",
  "text_multibuy_limited_offer_until_date": "Achats multiples, offre à durée limitée valable jusqu’au {date}",
  "text_app_membership_exclusive_multi_buy_until": "Offre en lot exclusive en ligne et sur l'appli jusqu'au {date}",
  "text_app_membership_exclusive_multi_buy": "Offre exclusive sur les achats multiples et sur l'application",
  "text_app_membership_exclusive_limitedoffers_until": "Offre exclusive sur les achats multiples et sur l'application jusqu'au {date}",
  "text_item_preorder_color_size_only": "Précommander (couleurs / tailles sélectionnées)",
  "text_item_resale_color_size_only": "De nouveau disponible (couleurs / tailles sélectionnées)"
}; // generated at Tue Jul 29 2025 17:10:40 GMT+0800 (Hong Kong Standard Time)